import { render, staticRenderFns } from "./ExportToXls.vue?vue&type=template&id=21b9e6c0&scoped=true"
import script from "./ExportToXls.vue?vue&type=script&lang=js"
export * from "./ExportToXls.vue?vue&type=script&lang=js"
import style0 from "./ExportToXls.vue?vue&type=style&index=0&id=21b9e6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9e6c0",
  null
  
)

export default component.exports